import React from 'react'
import helpToken from '@amzn/meridian-tokens/base/icon/help'
import Button from '@amzn/meridian/button'
import Icon from '@amzn/meridian/icon'
import { useBundle } from '@amzn/react-arb-tools'
import { BUNDLE_NAME } from '@src/constants'
import { t } from '@src/translationHelper'

interface IProblemSolveIconProps {
    toggleProblemSolve: () => void
}

export const shouldShowNotificationIcon = (): boolean => true

/**
 * Displays Profile icon
 * Clicking the icon opens the bottom sheet with multiple options.
 *
 * Usage:
 * <ProfileIcon toggleProfile={toggleProfile} />
 *
 * @returns {React.ReactElement}
 */
const ProblemSolveIcon = ({ toggleProblemSolve }: Readonly<IProblemSolveIconProps>): React.ReactElement => {
    const [bundle] = useBundle(BUNDLE_NAME)

    return (
        <Button type="icon" id={'help_button'} data-testid={'Help'} onClick={toggleProblemSolve}>
            <Icon tokens={helpToken}>{t(bundle, 'jsma-web-common-help')}</Icon>
        </Button>
    )
}

export default ProblemSolveIcon
